export const SKINS = [
  "color",
  "mono",
  // "winamp",
  "y2k",
  "matrix",
];

export const SKIN_LABELS = {
  color: "Slowed",
  mono: "Dark",
  // winamp: "Winamp",
  y2k: "Y2K",
  matrix: "Matrix",
};

export function resolveSkin(config) {
  if (SKINS.includes(config?.skinPreference)) return config.skinPreference;

  // Pre-skin installs stored a binary light/dark preference.
  if (config?.darkModePreference === "dark") return "mono";
  if (config?.darkModePreference === "light") return "color";
  if (config?.darkMode === true) return "mono";

  return "color";
}

export function nextSkin(skin) {
  const index = SKINS.indexOf(skin);
  return SKINS[(index + 1) % SKINS.length];
}
